var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadDuei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leave",
    clipPath: "url(#clip0_2901_31379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 264"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 210",
    cx: 51.7682,
    cy: 88.3577,
    rx: 33.8815,
    ry: 7.14286,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x8A\xAC\xED\x8D\xBC\xEC\x9A\x94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.2464 33.7262C69.0015 34.4754 77.6664 40.9648 83.0369 48.2797C83.812 49.339 84.511 50.4269 85.1131 51.534C85.4453 52.1209 85.7637 52.7126 86.0682 53.3042C89.8539 60.5619 92.2 68.4971 87.7084 76.022C80.5108 88.0847 62.4752 89.1774 42.0935 87.7793C38.5331 87.5378 35.039 86.9548 31.7124 86.0472C28.6255 85.2229 25.76 84.0488 23.2344 82.5735C15.6907 78.0309 12.9432 71.8993 13.22 66.1733C13.5314 58.9634 17.1787 54.2109 22.4108 47.9982C26.7432 42.8544 35.0689 37.2095 44.2459 34.8475C47.4243 33.9838 50.8349 33.6014 54.2464 33.7262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.8133 79.5586C73.9789 88.534 51.0088 90.1755 32.2119 86.4011",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M72.3242 39.1758C76.3668 41.7529 79.6763 44.8276 82.0825 48.2419C82.8577 49.306 83.5567 50.3939 84.1588 51.4961",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.1436 33.8835C49.841 33.6821 51.5676 33.6228 53.2857 33.707C58.2166 33.9191 63.0079 34.9206 67.2795 36.632",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.3672 50.1691C24.2602 44.1521 31.437 38.5502 40.8216 35.5059",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.2266 84.4921C21.9772 83.1894 18.1985 80.3789 16.4268 78.0312",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M57.5397 56.2622C57.0357 55.1419 56.2188 54.191 55.1873 53.5239C54.1557 52.8568 52.9534 52.502 51.7249 52.502C50.4965 52.502 49.2942 52.8568 48.2626 53.5239C47.231 54.191 46.4141 55.1419 45.9102 56.2622V56.2943C46.8338 58.8024 49.1174 61.7274 51.7281 61.7274C54.3389 61.7274 56.616 58.8024 57.5397 56.2943V56.2622Z",
    fill: "#FFAFA7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M62.5628 48.8552C62.5628 48.8552 59.7782 50.1702 57.7148 47.707",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M45.225 47.8535C45.225 47.8535 43.579 50.1536 39.9756 48.7521",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M88.0209 78.9259C86.2249 78.3512 84.4031 77.164 83.6974 74.7336C83.5743 74.3249 83.3525 73.9528 83.0515 73.6501C82.7505 73.3474 82.3797 73.1235 81.9717 72.9981C81.0835 72.7152 80.2716 72.2334 79.5977 71.5894C78.9237 70.9455 78.4056 70.1563 78.0826 69.2819C77.1285 66.9435 82.8868 61.9996 85.1061 63.2054C89.5272 65.608 89.596 71.9609 91.2891 75.007C91.5595 75.4896 91.6771 76.0428 91.6262 76.5936C91.5753 77.1444 91.3584 77.6668 91.0041 78.0916C90.6498 78.5164 90.1749 78.8236 89.6422 78.9726C89.1095 79.1216 88.5442 79.1053 88.0209 78.9259Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1714 71.9847C77.6088 70.9083 76.2497 64.246 78.6553 56.4028C78.7921 55.8465 79.0523 55.328 79.4165 54.8857C79.7808 54.4434 80.2397 54.0886 80.7595 53.8475C82.0076 53.3374 83.4471 53.708 84.6427 54.214C88.5404 55.8696 91.2834 58.8714 92.9821 62.7024C94.2784 65.6309 94.8695 69.1663 96.0552 72.0351C96.7403 73.6767 97.4862 75.2699 98.2929 76.8145C98.4995 77.1896 98.5957 77.6156 98.5702 78.0431C98.5503 78.5646 98.3443 79.0617 97.9896 79.4445C97.6349 79.8274 97.1549 80.0706 96.6365 80.1302C95.4218 80.2988 94.1851 80.0683 93.1128 79.4733C90.4121 77.972 88.7146 75.4591 89.4941 70.6977",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1714 71.9847C77.6088 70.9083 76.2497 64.246 78.6553 56.4028C78.7921 55.8465 79.0523 55.328 79.4165 54.8857C79.7808 54.4434 80.2397 54.0886 80.7595 53.8475C82.0076 53.3374 83.4471 53.708 84.6427 54.214C88.5404 55.8696 91.2834 58.8714 92.9821 62.7024C94.2784 65.6309 94.8695 69.1663 96.0552 72.0351C96.7403 73.6767 97.4862 75.2699 98.2929 76.8145C98.4995 77.1896 98.5957 77.6156 98.5702 78.0431C98.5503 78.5646 98.3443 79.0617 97.9896 79.4445C97.6349 79.8274 97.1549 80.0706 96.6365 80.1302C95.4218 80.2988 94.1851 80.0683 93.1128 79.4733C90.4121 77.972 88.7146 75.4591 89.4941 70.6977",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M86.6177 77.9206C85.7512 77.6317 84.9951 77.0819 84.4531 76.3465C83.0531 74.4175 83.0013 70.5783 84.3875 67.3569",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.3496 76.4393C13.46 76.4449 14.5534 76.1662 15.5257 75.6298C16.498 75.0934 17.3169 74.3171 17.9043 73.3748C18.1433 72.9936 18.4723 72.677 18.8625 72.453C19.2526 72.2289 19.6919 72.1042 20.1415 72.0899C21.125 72.053 22.0869 71.7914 22.9536 71.3251C23.8202 70.8588 24.5685 70.2002 25.1411 69.3998C26.7643 67.2894 22.6126 60.6439 20.0201 61.2536C14.8507 62.4591 12.6897 68.8834 10.1284 71.5371C9.71862 71.9519 9.44426 72.4812 9.34161 73.0552C9.23895 73.6292 9.31282 74.2208 9.55346 74.7519C9.79411 75.283 10.1902 75.7286 10.6894 76.0299C11.1886 76.3312 11.7675 76.4739 12.3496 76.4393Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2737 71.5527C25.1816 71.1734 28.4283 64.8095 28.1792 56.125C28.1964 55.521 28.0778 54.921 27.832 54.369C27.5862 53.8171 27.2197 53.3274 26.7593 52.9361C25.6313 52.0492 24.0615 52.0422 22.7055 52.2214C18.2721 52.8135 14.6443 55.1022 11.8434 58.5215C9.70176 61.1408 8.11134 64.5753 6.0986 67.1565C4.94507 68.6403 3.74037 70.0532 2.48453 71.3954C2.17409 71.7223 1.95825 72.1275 1.86004 72.5675C1.73361 73.1047 1.80412 73.6695 2.05877 74.1592C2.31342 74.6489 2.73531 75.031 3.24776 75.2361C4.43572 75.7454 5.75697 75.8551 7.01266 75.5486C10.1879 74.78 12.6132 72.6984 13.1601 67.6129",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2737 71.5527C25.1816 71.1734 28.4283 64.8095 28.1792 56.125C28.1964 55.521 28.0778 54.921 27.832 54.369C27.5862 53.8171 27.2197 53.3274 26.7593 52.9361C25.6313 52.0492 24.0615 52.0422 22.7055 52.2214C18.2721 52.8135 14.6443 55.1022 11.8434 58.5215C9.70176 61.1408 8.11134 64.5753 6.0986 67.1565C4.94507 68.6403 3.74037 70.0532 2.48453 71.3954C2.17409 71.7223 1.95825 72.1275 1.86004 72.5675C1.73361 73.1047 1.80412 73.6695 2.05877 74.1592C2.31342 74.6489 2.73531 75.031 3.24776 75.2361C4.43572 75.7454 5.75697 75.8551 7.01266 75.5486C10.1879 74.78 12.6132 72.6984 13.1601 67.6129",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.053 75.8037C15.0139 75.7497 15.9351 75.4019 16.6919 74.8072C18.6574 73.2377 19.7873 69.3507 19.2771 65.6827",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.053 75.8037C15.0139 75.7497 15.9351 75.4019 16.6919 74.8072C18.6574 73.2377 19.7873 69.3507 19.2771 65.6827",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7999 35.5832C50.4951 38.9761 55.7995 39.2235 58.9814 36.7534C57.9987 35.0503 55.5192 31.0911 50.6509 30.9552C48.942 30.8692 47.2379 31.2018 45.6868 31.9242C44.1357 32.6466 42.7844 33.7369 41.7506 35.1004",
    fill: "#FFF8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7999 35.5832C50.4951 38.9761 55.7995 39.2235 58.9814 36.7534C57.9987 35.0503 55.5192 31.0911 50.6509 30.9552C48.942 30.8692 47.2379 31.2018 45.6868 31.9242C44.1357 32.6466 42.7844 33.7369 41.7506 35.1004",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 435",
    d: "M46.7261 11.7981C54.2755 9.88034 59.4229 14.483 54.6187 18.1268C49.8145 21.7706 47.9271 21.5787 46.7261 19.8528C45.525 18.1268 48.9566 14.6747 53.5892 16.4008C58.2218 18.1268 59.079 23.3048 56.8489 23.3048C54.6187 23.3048 48.7844 21.5789 51.1868 18.1268C53.5892 14.6748 49.6432 11.4145 46.7261 13.9076C43.8089 16.4008 40.8918 20.2363 43.8089 21.7706C46.7261 23.3048 53.5892 27.7289 53.5892 23.3048C53.5892 18.8807 45.8671 11.4145 43.8089 13.9076C41.7507 16.4008 43.7668 24.4555 46.4691 25.2705C49.1715 26.0856 55.7344 23.9281 57.7933 19.5172C59.4405 15.9884 59.4519 14.3072 59.2517 13.9076",
    stroke: "#868686",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 436",
    d: "M17.168 20.1426V37.8821",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 437",
    d: "M26.2285 10.002V29.0119",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 438",
    d: "M36.1406 4.5V23.8763",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 439",
    d: "M86.2598 20.1426V37.8821",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 440",
    d: "M77.1982 10.002V29.0119",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 441",
    d: "M67.2861 4.5V23.8763",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 442",
    d: "M42.3805 61.742C44.1146 59.2961 43.7147 56.005 43.298 54.6652C43.0747 53.6969 39.097 52.9439 38.1029 53.4133C37.1088 53.8828 37.3342 54.5597 37.3905 57.6515C37.4467 60.7433 34.3827 59.7801 31.6001 62.5856C28.8176 65.391 28.9711 69.8378 29.3502 72.039C29.7293 74.2402 36.3794 76.6728 37.4453 75.3559C38.5112 74.0391 35.9031 70.194 37.2509 66.8006C38.5987 63.4073 40.2128 64.7994 42.3805 61.742Z",
    fill: "#DCF8FF",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 443",
    d: "M61.2002 61.5217C59.3139 59.1544 59.3877 55.8813 59.6604 54.5407C59.7831 53.5744 63.5138 52.7006 64.5078 53.1338C65.5018 53.5669 65.3497 54.2447 65.5856 57.3093C65.8215 60.3739 68.6593 59.3214 71.5813 62.0111C74.5032 64.7009 74.773 69.111 74.6169 71.3037C74.4608 73.4964 68.3337 76.1197 67.1917 74.8495C66.0497 73.5792 68.1819 69.6864 66.576 66.3682C64.9701 63.05 63.5581 64.4808 61.2002 61.5217Z",
    fill: "#DCF8FF",
    stroke: "#868686",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2901_31379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadDuei);
export default __webpack_public_path__ + "static/media/SadDuei.b87eb610fe3c0c6cd8d377a4dc119746.svg";
export { ForwardRef as ReactComponent };